export default __webpack_public_path__ + "static/media/ic-loc.e84cd3e5.svg";